import axios from 'axios'
import { observable, action, runInAction } from 'mobx'

export const MAINTENANCE_ERROR_CODE = 'TENANT_MAINTENANCE'
export const MAINTENANCE_HEADER = 'x-tenant-maintenance'

// Enquanto a tela de manutenção estiver aberta, pergunta ao servidor a cada minuto se já acabou.
const POLL_INTERVAL_MS = 60 * 1000
// Fora da manutenção, confere de tempos em tempos se ela começou.
const BACKGROUND_INTERVAL_MS = 3 * 60 * 1000

/**
 * Modo manutenção do tenant, ligado pelo PlantScanner Admin.
 * A API responde 503 { code: 'TENANT_MAINTENANCE', message, until } para os usuários do cliente;
 * a equipe @plantscanner.io continua entrando e recebe o cabeçalho X-Tenant-Maintenance.
 */
export default class MaintenanceStore {
  @observable active = false
  @observable message = undefined
  @observable until = undefined
  @observable bypass = false
  @observable checking = false
  @observable lastCheck = undefined

  pollTimer = undefined
  backgroundTimer = undefined

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  static isMaintenanceError(error) {
    const response = error && error.response
    return Boolean(
      response &&
        response.status === 503 &&
        response.data &&
        response.data.code === MAINTENANCE_ERROR_CODE
    )
  }

  @action.bound
  enter(data) {
    const wasActive = this.active
    this.active = true
    this.bypass = false
    this.message = (data && data.message) || undefined
    this.until = (data && data.until) || undefined
    if (!wasActive) this.startPolling()
  }

  // Equipe PlantScanner entrando num tenant em manutenção: só mostra o aviso no topo.
  @action.bound
  markBypass(isActive) {
    if (this.active) return
    this.bypass = Boolean(isActive)
  }

  @action.bound
  async check() {
    if (this.checking) return
    this.checking = true
    try {
      const { data } = await axios.get('/maintenance/status', { __maintenanceCheck: true })
      runInAction(() => {
        this.lastCheck = new Date()
        if (data && data.active && !data.bypass) {
          this.enter(data)
          return
        }
        if (data && data.active && data.bypass) this.markBypass(true)
        if (this.active) {
          // Manutenção encerrada: recarrega para o portal voltar do zero, com dados atualizados.
          this.stopPolling()
          window.location.reload()
        }
      })
    } catch (error) {
      runInAction(() => {
        this.lastCheck = new Date()
      })
    } finally {
      runInAction(() => {
        this.checking = false
      })
    }
  }

  // Verificação leve em segundo plano para quem está logado (ex.: tablet do posto parado só no
  // tempo real, sem chamadas à API): a manutenção aparece em até alguns minutos mesmo assim.
  startBackgroundCheck() {
    if (this.backgroundTimer) return
    this.backgroundTimer = setInterval(() => {
      if (!this.active && this.rootStore.authStore.isLoggedIn) this.check()
    }, BACKGROUND_INTERVAL_MS)
  }

  startPolling() {
    this.stopPolling()
    this.pollTimer = setInterval(() => this.check(), POLL_INTERVAL_MS)
  }

  stopPolling() {
    if (this.pollTimer) clearInterval(this.pollTimer)
    this.pollTimer = undefined
  }
}
